<template>
  <div
    class="modal fade"
    id="studioInfoMModal"
    tabindex="-1"
    aria-labelledby="studioInfoMLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex">
            <h1 class="modal-title fs-5">STUDIO 정보 수정</h1>
          </div>
        </div>
        <div class="modal-division" />
        <div class="modal-body" style="padding-top: 1rem">
          <div class="modalDivWrap">
            <div class="modalPartTitle">기본 정보</div>
            <div class="modalInputDiv">
              <label>사업자등록번호</label>
              <input type="text" :value="businessNumberFormatted" disabled />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>스튜디오명</label>
              <input
                type="text"
                placeholder="스튜디오명을 입력해주세요"
                v-model="studioName"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>대표자명</label>
              <input
                type="text"
                placeholder="대표자명을 입력해주세요"
                v-model="ceoName"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>연락처</label>
              <input
                type="text"
                placeholder="연락처를 입력해주세요 (ex. 02-1234-5678)"
                v-model="phoneNumber"
                @input="changePhoneNumber"
                maxlength="13"
              />
              <div class="modalInputRight" />
            </div>
          </div>

          <div class="modalDivWrap">
            <div class="modalPartTitle">주소 정보</div>
            <div class="modalInputDiv">
              <label>시/도</label>
              <input
                type="text"
                placeholder="시/도를 입력해주세요"
                v-model="addrOne"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>시/군/구</label>
              <input
                type="text"
                placeholder="시/군/구를 입력해주세요"
                v-model="addrTwo"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>읍/면/동</label>
              <input
                type="text"
                placeholder="읍/면/동을 입력해주세요"
                v-model="addrThree"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>상세 주소</label>
              <input
                type="text"
                placeholder="상세 주소를 입력해주세요"
                v-model="addrDetail"
              />
              <div class="modalInputRight" />
            </div>
          </div>

          <div class="modalDivWrap" style="border-bottom: none">
            <div class="modalPartTitle">계정 정보</div>
            <div v-if="accounts && accounts.length > 0">
              <div
                class="accountCard"
                v-for="(account, index) in accounts"
                :key="index"
              >
                <div class="accountRow">
                  <span class="accountLabel">아이디</span>
                  <span class="accountValue">{{
                    account.username || "-"
                  }}</span>
                </div>
                <div class="accountRow">
                  <span class="accountLabel">이름</span>
                  <span class="accountValue">{{ account.name || "-" }}</span>
                </div>
                <div class="accountRow">
                  <span class="accountLabel">연락처</span>
                  <span class="accountValue">{{
                    account.mobile ? phoneNumberFormatter(account.mobile) : "-"
                  }}</span>
                </div>
                <div class="accountRow">
                  <span class="accountLabel">초기설정</span>
                  <span
                    class="accountValue"
                    :class="
                      account.isFirstLogin === 'Y'
                        ? 'statusPending'
                        : 'statusDone'
                    "
                  >
                    {{ account.isFirstLogin === "Y" ? "미완료" : "완료" }}
                  </span>
                </div>
                <!-- 계정별 2차 인증 창(REQ-ACC-012) — 병원·제조사 계정 화면과 같은 버튼 -->
                <div class="accountActions">
                  <div
                    type="button"
                    class="certi-custom-btn"
                    style="white-space: nowrap"
                    @click="openSecurity(account)"
                  >
                    2차 인증
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="noAccount">등록된 계정이 없습니다.</div>
          </div>
        </div>
        <!-- 운영자 회사 강제 스위치(C8, REQ-ACC-012) -->
        <div class="px-4">
          <company-two-factor-policy-switch :company-id="studioId" />
          <!-- 고객 지원을 위한 접근(동의 스위치·지원 계정·지원 접속 — W6 A3) -->
          <support-access-card :company-id="studioId" company-type="STUDIO" :company-name="studioName" />
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666"
          >
            취소
          </button>
          <button type="button" class="btn btn-info" @click="modifyStudio()">
            수정하기
          </button>
        </div>
      </div>
    </div>
    <!-- 2차 인증 창(상태·예외·잠금·초기화·이력). ant 모달이라 body 로 옮겨 그려진다 -->
    <account-security-modal :account="securityAccount" @close="closeSecurity" />
  </div>
</template>

<script>
import AccountSecurityModal from "@/views/components/AccountSecurityModal.vue";
import CompanyTwoFactorPolicySwitch from "@/views/components/CompanyTwoFactorPolicySwitch.vue";
import SupportAccessCard from "@/views/components/SupportAccessCard.vue";
import {
  openDialog,
  businessNumberFormatter,
  phoneNumberFormatter,
} from "@/utils/utils";
import bootstrapJs from "bootstrap/dist/js/bootstrap";

export default {
  name: "StudioInfoM",
  components: { AccountSecurityModal, CompanyTwoFactorPolicySwitch, SupportAccessCard },
  emits: ["reload"],
  data() {
    return {
      studioId: "",
      businessNumber: "",
      studioName: "",
      ceoName: "",
      phoneNumber: "",
      addrOne: "",
      addrTwo: "",
      addrThree: "",
      addrDetail: "",
      accounts: [],
      securityAccount: null, // 「2차 인증」 창을 연 계정
    };
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    businessNumberFormatted() {
      return businessNumberFormatter(this.businessNumber);
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue && newValue.studioId !== this.studioId) {
          this.initValues();

          if (newValue.studioId) this.studioId = newValue.studioId;
          if (newValue.cNo) this.businessNumber = newValue.cNo;
          if (newValue.name) this.studioName = newValue.name;
          if (newValue.ceo) this.ceoName = newValue.ceo;
          if (newValue.call) {
            this.phoneNumber = newValue.call;
            this.changePhoneNumber();
          }

          if (newValue.address) {
            if (newValue.address.addrOne)
              this.addrOne = newValue.address.addrOne;
            if (newValue.address.addrTwo)
              this.addrTwo = newValue.address.addrTwo;
            if (newValue.address.addrThree)
              this.addrThree = newValue.address.addrThree;
            if (newValue.address.addrDetail)
              this.addrDetail = newValue.address.addrDetail;
          }

          if (newValue.accounts && Array.isArray(newValue.accounts)) {
            this.accounts = newValue.accounts;
          }
        }
      },
    },
  },
  methods: {
    phoneNumberFormatter,

    changePhoneNumber() {
      this.phoneNumber = phoneNumberFormatter(this.phoneNumber.toString());
    },

    async modifyStudio() {
      const obj = {};

      if (this.studioName) obj.name = this.studioName;
      if (this.ceoName) obj.ceo = this.ceoName;
      if (this.phoneNumber) obj.call = this.phoneNumber.replace(/-/g, "");
      if (this.addrOne) obj.addrOne = this.addrOne;
      if (this.addrTwo) obj.addrTwo = this.addrTwo;
      if (this.addrThree) obj.addrThree = this.addrThree;
      if (this.addrDetail) obj.addrDetail = this.addrDetail;

      // try/catch 는 API 호출에만 적용: 성공 후 UI 처리 오류가 실패 팝업으로 보고되지 않도록 함
      let success = false;
      try {
        const response = await this.$apiInstance.put(
          `/admin/studios/${this.studioId}`,
          obj
        );
        success = response.status === 200 || response.status === 201;
      } catch (error) {
        console.log(error);
      }

      if (!success) {
        await openDialog("STUDIO 정보 수정에 실패하였습니다.", "error", "확인");
        return;
      }

      await openDialog(
        "STUDIO 정보 수정이 완료되었습니다.",
        "success",
        "확인"
      );
      this.$emit("reload");
      this.closeModal();
    },

    closeModal() {
      const modal = document.getElementById("studioInfoMModal");
      if (modal) {
        bootstrapJs.Modal.getOrCreateInstance(modal).hide();
      }
    },

    // 부트스트랩 모달 위에 ant 모달을 겹치면 focus trap 이 입력 칸 포커스를 뺏고 확인창(Swal)이 가려진다.
    // 그래서 이 창을 잠시 닫고 「2차 인증」 창을 연 뒤, 닫으면 이 창을 다시 연다(입력 중인 값은 그대로)
    openSecurity(account) {
      this.closeModal();
      this.securityAccount = { ...account, corpName: this.data.name };
    },

    closeSecurity() {
      this.securityAccount = null;
      const modal = document.getElementById("studioInfoMModal");
      if (!modal) return;
      const instance = bootstrapJs.Modal.getOrCreateInstance(modal);
      // 「2차 인증」 창을 연 직후 닫으면 이 창은 아직 닫히는 중(창 → 배경 순)이라 show() 가 무시되거나 배경이 지워진다.
      // 다 닫힌 뒤('hidden.bs.modal') 한 번 연다.
      // ponytail: 부트스트랩 5.2 내부 필드(_isShown·_isTransitioning·_backdrop._isAppended)에 기댐 — 버전을 올리면 확인
      if (!instance._isShown && (instance._isTransitioning || instance._backdrop?._isAppended)) {
        modal.addEventListener("hidden.bs.modal", () => instance.show(), { once: true });
        return;
      }
      instance.show();
    },

    initValues() {
      this.studioId = "";
      this.businessNumber = "";
      this.studioName = "";
      this.ceoName = "";
      this.phoneNumber = "";
      this.addrOne = "";
      this.addrTwo = "";
      this.addrThree = "";
      this.addrDetail = "";
      this.accounts = [];
    },
  },
};
</script>

<style scoped>
.modalDivWrap {
  padding: 1rem;
  border-bottom: 1px solid #eee;
}
.modalPartTitle {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}
.modalInputDiv {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
}
.modalInputDiv label {
  width: 150px;
  min-width: 150px;
}
.modalInputDiv input[type="text"],
.modalInputDiv input[type="password"] {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.modalInputDiv input:disabled {
  background-color: #f5f5f5;
  color: #666;
}
.modalInputRight {
  width: 100px;
  min-width: 100px;
  display: flex;
  justify-content: flex-end;
}
.accountCard {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.75rem;
}
.accountCard:last-child {
  margin-bottom: 0;
}
.accountRow {
  display: flex;
  padding: 0.35rem 0;
}
.accountLabel {
  width: 80px;
  font-weight: 500;
  color: #555;
  font-size: 0.9rem;
}
.accountValue {
  color: #333;
  font-size: 0.9rem;
}
.accountActions {
  display: flex;
  justify-content: flex-end;
  padding-top: 0.35rem;
}
.statusPending {
  color: #f39c12;
  font-weight: 500;
}
.statusDone {
  color: #27ae60;
  font-weight: 500;
}
.noAccount {
  text-align: center;
  color: #999;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}
</style>
